<div [ngStyle]="{ 'min-height.px': height ? height : 500 }" fxLayoutAlign="center center">
  <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
</div>
